import { render, staticRenderFns } from "./bbgl-plks.vue?vue&type=template&id=2445e577&scoped=true"
import script from "./bbgl-plks.vue?vue&type=script&lang=js"
export * from "./bbgl-plks.vue?vue&type=script&lang=js"
import style0 from "./bbgl-plks.vue?vue&type=style&index=0&id=2445e577&prod&lang=scss"
import style1 from "./bbgl-plks.vue?vue&type=style&index=1&id=2445e577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445e577",
  null
  
)

export default component.exports